/** @format */

import { Modal, Space } from "antd";
import { ColumnsType } from "antd/lib/table";
import { ButtonTableDelete, ButtonTableEdit } from "components/Button";
import { formatCurr } from "utils/helper";

type ColumnAlokasiType = {
  provinsi: any[];
  kabkota: any[];
  handleEdit: (val: any) => void;
  handleDelete: (val: any) => void;
};

export const columnsAlokasi = ({
  provinsi,
  kabkota,
  handleEdit,
  handleDelete,
}: ColumnAlokasiType): ColumnsType<any> => {
  /** Lookup map supaya tidak find setiap render */
  const provinsiMap = new Map(provinsi.map((p) => [p.kode, p.nama]));
  const kabkotaMap = new Map(kabkota.map((k) => [k.kode, k.nama]));

  return [
    {
      title: "NSM",
      key: "nsm",
      dataIndex: "nsm",
    },
    {
      title: "Madrasah",
      dataIndex: "namaMadrasah",
      key: "namaMadrasah",
    },
    {
      title: "Jenjang",
      dataIndex: "jenjang",
      key: "jenjang",
      render: (jenjang: string) => <div className="uppercase">{jenjang}</div>,
    },
    {
      title: "Provinsi",
      dataIndex: "kodeProvinsi",
      key: "kodeProvinsi",
      render: (kodeProvinsi: string) => provinsiMap.get(kodeProvinsi) || "",
    },
    {
      title: "Kabkota",
      dataIndex: "kodeKabKota",
      key: "kodeKabKota",
      render: (kodeKabKota: string) => kabkotaMap.get(kodeKabKota) || "",
    },

    {
      title: "Alokasi Anggaran",
      key: "nominal",
      children: [
        {
          title: "Semester 1",
          dataIndex: "apbn_bos_semester1",
          key: "apbn_bos_semester1",
          render: (val: number) => (
            <div className="text-right">{formatCurr(val)}</div>
          ),
        },
        {
          title: "Semester 2",
          dataIndex: "apbn_bos_semester2",
          key: "apbn_bos_semester2",
          render: (val: number) => (
            <div className="text-right">{formatCurr(val)}</div>
          ),
        },
        {
          title: "Triwulan 1",
          dataIndex: "apbn_bos_triwulan1",
          key: "apbn_bos_triwulan1",
          render: (val: number) => (
            <div className="text-right">{formatCurr(val)}</div>
          ),
        },
        {
          title: "Triwulan 2",
          dataIndex: "apbn_bos_triwulan2",
          key: "apbn_bos_triwulan2",
          render: (val: number) => (
            <div className="text-right">{formatCurr(val)}</div>
          ),
        },
        {
          title: "Triwulan 3",
          dataIndex: "apbn_bos_triwulan3",
          key: "apbn_bos_triwulan3",
          render: (val: number) => (
            <div className="text-right">{formatCurr(val)}</div>
          ),
        },
        {
          title: "Triwulan 4",
          dataIndex: "apbn_bos_triwulan4",
          key: "apbn_bos_triwulan4",
          render: (val: number) => (
            <div className="text-right">{formatCurr(val)}</div>
          ),
        },
        {
          title: "Nominal Non AA",
          key: "nonAA",
          render: (_: any, record: any) => (
            <div className="text-right">
              {formatCurr(
                (record?.apbn_bos_semester2 || 0) - (record?.nilaiAa || 0),
              )}
            </div>
          ),
        },
        {
          title: "Nominal AA",
          dataIndex: "nilaiAa",
          key: "nilaiAa",
          render: (val: number) => (
            <div className="text-right">{formatCurr(val)}</div>
          ),
        },
        {
          title: "Nilai Optimalisasi",
          dataIndex: "nilai_optimalisasi",
          key: "nilai_optimalisasi",
          render: (val: number) => (
            <div className="text-right">{formatCurr(val)}</div>
          ),
        },
        {
          title: "Total",
          key: "total",
          render: (_: any, record: any) => (
            <div className="text-right">
              {formatCurr(
                (record.apbn_bos_semester1 || 0) +
                  (record.apbn_bos_semester2 || 0) +
                  (record.apbn_bos_triwulan1 || 0) +
                  (record.apbn_bos_triwulan2 || 0) +
                  (record.apbn_bos_triwulan3 || 0) +
                  (record.apbn_bos_triwulan4 || 0),
              )}
            </div>
          ),
        },
      ],
    },

    {
      title: "Jumlah Siswa",
      dataIndex: "jumlahSiswa",
      key: "jumlahSiswa",
    },

    {
      title: "Rekening Madrasah",
      key: "rekening",
      children: [
        {
          title: "Nama Bank",
          dataIndex: "namaBank",
          key: "namaBank",
        },
        {
          title: "No Rekening",
          dataIndex: "nomorRekening",
          key: "nomorRekening",
        },
        {
          title: "Nama Pemilik",
          dataIndex: "namaPemilikRekening",
          key: "namaPemilikRekening",
        },
      ],
    },

    {
      title: "Aksi",
      key: "aksi",
      width: 150,
      fixed: "right" as const,
      render: (_: any, record: any) => (
        <Space>
          <ButtonTableEdit onClick={() => handleEdit(record)} />

          <ButtonTableDelete
            onClick={() => {
              Modal.confirm({
                title: "Perhatian",
                content: "Yakin Hapus Data?",
                centered: true,
                wrapClassName: "erkam-custom-modal",
                okText: "Hapus",
                cancelText: "Batal",
                okType: "danger",
                onOk() {
                  return handleDelete(record);
                },
              });
            }}
          />
        </Space>
      ),
    },
  ];
};
